import { render } from "./GoogleAuthBtn.vue?vue&type=template&id=1b7aa6b5&scoped=true"
import script from "./GoogleAuthBtn.vue?vue&type=script&lang=js"
export * from "./GoogleAuthBtn.vue?vue&type=script&lang=js"

import "./GoogleAuthBtn.vue?vue&type=style&index=0&id=1b7aa6b5&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7aa6b5"]])

export default __exports__